module.exports = __webpack_public_path__ + "static/img/spin_bottom_24.0d28612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_spin/spin_bottom_24.png
// module id = saee
// module chunks = 6